import { http } from "../client";
import { mapTrackObject } from "../tracks/map";
export var getDeviceDetail = function (id) {
    return http.api
        .get("devices/" + id)
        .then(function (response) { return response.data.data; })
        .then(function (_a) {
        var id = _a.id, title = _a.title, timetable_id = _a.timetable_id, _b = _a.status, isOnline = _b.isOnline, isPlaying = _b.isPlaying, nowPlaying = _b.nowPlaying;
        return ({
            id: id,
            title: title,
            timetableId: timetable_id,
            isOnline: isOnline,
            isPlaying: isPlaying,
            nowPlaying: nowPlaying ? mapTrackObject(nowPlaying) : null,
        });
    });
};
